import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_3552_12826)">
        <path
          d="M18.2037 8.79175V7.75986C18.2037 4.19331 15.3011 1.2915 11.7344 1.2915H10.1382C6.5715 1.2915 3.66961 4.19334 3.66961 7.75986V8.79175C2.61671 8.82059 1.77032 9.67909 1.77032 10.7398V13.2502C1.77032 14.3288 2.64486 15.2033 3.72288 15.2033C3.89239 15.2033 4.05433 15.1745 4.211 15.1349C4.71195 16.4291 6.00876 18.3272 9.33165 18.795C9.5677 19.4571 10.194 19.9331 10.9368 19.9331C11.8817 19.9331 12.6476 19.1673 12.6476 18.2224C12.6476 17.2774 11.8817 16.5118 10.9368 16.5118C10.2792 16.5118 9.71423 16.8866 9.42816 17.4317C6.46541 16.9769 5.60239 15.2073 5.35599 14.3181C5.55691 14.011 5.67587 13.6458 5.67587 13.2509V10.7399C5.67587 10.4438 5.6049 10.1654 5.48708 9.91396V7.75997C5.48708 5.19456 7.57402 3.10848 10.1387 3.10848H11.735C14.2997 3.10848 16.3873 5.19536 16.3873 7.75997V9.91396C16.2684 10.1667 16.1985 10.4436 16.1985 10.7399V13.2504C16.1985 14.3289 17.0718 15.2034 18.1504 15.2034C19.229 15.2034 20.1035 14.3289 20.1035 13.2504L20.1037 10.7399C20.1029 9.6792 19.2573 8.8207 18.2035 8.79185L18.2037 8.79175Z"
          fill={colorValue}
        />
      </g>
      <defs>
        <clipPath id="clip0_3552_12826">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.937012 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
